import { Button, ButtonTypes, DatePicker, IconWeight, type IconType, Input } from "@clintonelec/react-storybook";
import { DateUnits } from "@clintonelec/typescriptutils";
import "Components/PlaybackLayout/TimelineHeader/TimelineHeader.less";
import {
	selectClipModeActive, selectClipName, selectDate, selectVideoPlayerTime, setClipModeActiveAction, setClipNameAction,
	setDateAction
} from "Data/Redux/Slices/Playback";
import { useAppDispatch, useAppSelector } from "Data/Redux/Store";
import { Fragment, memo, useState } from "react";

function TimelineHeader() {
	const dispatch = useAppDispatch();
	const clipName = useAppSelector(selectClipName);
	const clipModeActive = useAppSelector(selectClipModeActive);
	const timelineDate = useAppSelector(selectDate);
	const videoPlayerTime = useAppSelector(selectVideoPlayerTime);
	const [ datepickerOpen, setDatepickerOpen ] = useState(false);
	const handleDatePickerOpen = () => setDatepickerOpen(!datepickerOpen);
	const handleClipNameUpdate = (value: string) => dispatch(setClipNameAction(value));
	const handleDateChange = (value: Date | null) => dispatch(setDateAction(value ? value.toISOString() : null));
	const handleClipModeActiveClick = () => dispatch(setClipModeActiveAction(!clipModeActive));
	const isLive = new Date().getTime() - (new Date(videoPlayerTime ?? 0).getTime()) < 5 * DateUnits.SECONDS;
	const liveIcon: IconType = {
		name: "arrow-right-to-line",
		weight: IconWeight.SOLID
	};

	const renderClipContent = () => {
		if (!clipModeActive) {
			return;
		}

		return (
			<Fragment>
				<Input placeholder="Clip Name" value={ clipName } onUpdate={ handleClipNameUpdate } />
				<Button type={ ButtonTypes.TERTIARY }>Submit</Button>
				<Button type={ ButtonTypes.DANGER } onClick={ handleClipModeActiveClick }>Cancel</Button>
			</Fragment>
		);
	};

	const renderLive = () => {
		if (isLive || !timelineDate || clipModeActive) {
			return;
		}

		const handleGoToLiveClick = () => handleDateChange(new Date());

		return (
			<Button icon={ liveIcon } onClick={ handleGoToLiveClick } type={ ButtonTypes.DANGER }>Live</Button>
		);
	};

	return (
		<div className="timeline-header">
			<div className="left-content">
				{ renderLive() }
			</div>
			<div className="center-content">
				<DatePicker
					onChange={ handleDateChange }
					value={ !timelineDate || datepickerOpen ? timelineDate : new Date(videoPlayerTime ?? 0) }
					onOpen={ handleDatePickerOpen }
					onClose={ handleDatePickerOpen }
				/>
			</div>
			<div className="right-content">
				{ renderClipContent() }
			</div>
		</div>
	);
}

export default memo(TimelineHeader);
